




import Vue from 'vue'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

am4core.useTheme(am4themes_animated)

interface ComponentData {
  chart: any
}

export default Vue.extend({
  name: 'ProductSalesAndBudgetGraph',

  props: {
    chartData: {
      type: Object as () => any
    },
  },

  data (): ComponentData {
    return {
      chart: undefined,
    }
  },

  watch: {
    chartData (newVal: any): void {
      this.createChart()
    }
  },

  methods: {
    createChart (): any {
      //@ts-ignore
      let chart = am4core.create(this.$refs.columnChart, am4charts.XYChart)

      const data = [
          { "month": 1, "label": "Jan", "value1": null, "value2": null },
          { "month": 2, "label": "Feb", "value1": null, "value2": null },
          { "month": 3, "label": "Mar", "value1": null, "value2": null },
          { "month": 4, "label": "Apr", "value1": null, "value2": null },
          { "month": 5, "label": "Mai", "value1": null, "value2": null },
          { "month": 6, "label": "Jun", "value1": null, "value2": null },
          { "month": 7, "label": "Jul", "value1": null, "value2": null },
          { "month": 8, "label": "Aug", "value1": null, "value2": null },
          { "month": 9, "label": "Sep", "value1": null, "value2": null },
          { "month": 10, "label": "Okt", "value1": null, "value2": null },
          { "month": 11, "label": "Nov", "value1": null, "value2": null },
          { "month": 12, "label": "Dez", "value1": null, "value2": null }
      ]

      chart.data = data.map((item: any) => {
        this.chartData.months.forEach((i: any) => {
          if (i.id === item.month) {
            item.value1 = i.value
          }
        })

        this.chartData.months2.forEach((i: any) => {
          if (i.id === item.month) {
            item.value2 = i.value
          }
        })

        return item
      })

      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis())
      categoryAxis.dataFields.category = "label"
      categoryAxis.renderer.grid.template.location = 0
      categoryAxis.renderer.minGridDistance = 20

      chart.yAxes.push(new am4charts.ValueAxis())

      // Create series
      function createSeries(field: any, name: any, color: any, dashed: boolean = false, showBullets: boolean = true, strokeWidth: number = 3) {
        let series: any = chart.series.push(new am4charts.LineSeries())
        series.dataFields.valueY = field
        series.dataFields.categoryX = "label"
        series.name = name
        series.tooltipText = "{valueY}"
        series.strokeWidth = strokeWidth
        if(color) {
          series.stroke = am4core.color(color)
        }
        if (dashed) {
          series.tooltipText = "{valueY.formatNumber('#.00')}"
          series.strokeDasharray = "5,5"
        }

        if (showBullets) {
          let bullet: any = series.bullets.push(new am4charts.CircleBullet())
          bullet.circle.stroke = am4core.color("#fff")
          bullet.circle.strokeWidth = 1
          if (color) {
            bullet.fill = am4core.color(color)
          }
        }

        return series
      }

      createSeries("value2", 'Umsatz', "#0000FF")
      createSeries("value1", 'Betrag', "#FF0000")

      chart.legend = new am4charts.Legend()
      chart.zoomOutButton.disabled = true
    }
  },

  mounted () {
    this.createChart()
  },

  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }
})
